import { customizeCraftJsComponent } from '../../helpers';
import { EditorButton } from '../EditorButton';

export const EditorSSOButton = customizeCraftJsComponent(EditorButton, {
	name: 'SSO Button',
	props: {
		children: '',
		startIcon: 'sso',
		shape: 'square',
		variant: 'outline',
		startIconColorText: true,
		'data-type': 'sso'
	}
});
